<nav class="navbar navbar-expand p-2">
  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto ">
      <!-- <a class="nav-link" routerLink="/home" routerLinkActive="active">Home</a>
            <a class="nav-link" routerLink="/create-template" routerLinkActive="active">Create Template</a>
         -->
      <li class="nav-item">
        <a
          class="nav-link"
          routerLink="/home"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <i class="pi pi-home text-white"></i>
          Home
        </a
        >
      </li>

      <!-- Campaigns dropdown -->
      <li class="nav-item dropdown">
        <a
          class="nav-link dropdown-toggle"
          href="#"
          id="campaignsDropdown"
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i class="pi pi-address-book text-white"></i>
          Campaigns
        </a>
        <ul class="dropdown-menu" aria-labelledby="campaignsDropdown">
          <li>
            <a class="dropdown-item" routerLink="/campaign/list" routerLinkActive="active">
              <i class="pi pi-address-book "></i>
              List Campaigns
            </a>
          </li>
          <li>
            <a class="dropdown-item" routerLink="/campaign/new" routerLinkActive="active">
              <i class="pi pi-plus-circle"></i>
              Create Campaign
            </a>
          </li>
          <li>
            <a
              class="dropdown-item"
              routerLink="/email-template"
              routerLinkActive="active"
            ><i class="pi pi-envelope mr-1"></i>Email Templates</a
            >
          </li>
          <li>
            <a
              class="dropdown-item"
              routerLink="/email-template-v2"
              routerLinkActive="active"
            ><i class="pi pi-envelope mr-1"></i>Email Templates V2</a
            >
          </li>
          <li>
            <a
              class="dropdown-item"
              routerLink="/sms-template"
              routerLinkActive="active"
            ><i class="pi pi-comment mr-1"></i>SMS Templates</a
            >
          </li>
          <li>
            <a
              class="dropdown-item"
              routerLink="/web-push-template"
              routerLinkActive="active"
            ><i class="bi bi-chat-left-text mr-1"></i>Web Push Templates</a
            >
          </li>
          <li>
            <a
              class="dropdown-item"
              routerLink="/push-template"
              routerLinkActive="active"
            ><i class="bi bi-app-indicator mr-1"></i>Push Templates</a
            >
          </li>
          <li>
            <a
              class="dropdown-item"
              routerLink="/whatsapp-template"
              routerLinkActive="active"
            ><i class="bi bi-whatsapp mr-1"></i>Whatsapp Templates</a
            >
          </li>
          <li>
            <a
              class="dropdown-item"
              routerLink="/viber-template"
              routerLinkActive="active"
            ><i class="bi bi-telegram mr-1"></i>Viber Templates</a
            >
          </li>
          <li>
            <a
              class="dropdown-item"
              routerLink="/rcs-template"
              routerLinkActive="active"
            ><i class="bi bi-chat-dots mr-1"></i>RCS Templates</a
            >
          </li>
          <li>
            <a
              class="dropdown-item"
              routerLink="/rsa-search-template"
              routerLinkActive="active"
            ><i class="bi bi-google mr-1"></i>Google RSA Search Templates</a
            >
          </li>
          <li>
            <a
              class="dropdown-item"
              routerLink="/gen-single-image-template"
              routerLinkActive="active"
            ><i class="bi bi-google mr-1"></i>Google Demand Gen Single Image Templates</a
            >
          </li>
          <li>
            <a
              class="dropdown-item"
              routerLink="/gen-video-template"
              routerLinkActive="active"
            ><i class="bi bi-google mr-1"></i>Google Demand Gen Video Templates</a
            >
          </li>
          <li>
            <a
              class="dropdown-item"
              routerLink="/performance-max-template"
              routerLinkActive="active"
            ><i class="bi bi-google mr-1"></i>Google Performance Max Templates</a
            >
          </li>
          <li>
            <a
              class="dropdown-item"
              routerLink="/youtube-video-template"
              routerLinkActive="active"
            ><i class="bi bi-google mr-1"></i>Google YouTube Video Ad Templates</a
            >
          </li>
          <li>
            <a
              class="dropdown-item"
              routerLink="/meta-single-image-template"
              routerLinkActive="active"
            ><i class="bi bi-meta mr-1"></i>Meta Single Image Ad Templates</a
            >
          </li>
          <li>
            <a
              class="dropdown-item"
              routerLink="/meta-video-template"
              routerLinkActive="active"
            ><i class="bi bi-meta mr-1"></i>Meta Video Ad Templates</a
            >
          </li>
          <li>
            <a
              class="dropdown-item"
              routerLink="/meta-carousel-template"
              routerLinkActive="active"
            ><i class="bi bi-meta mr-1"></i>Meta Carousel Ad Templates</a
            >
          </li>
        </ul>
      </li>

      <li class="nav-item">
        <a
          class="nav-link"
          routerLink="/properties"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <i class="pi pi-building text-white"></i>
          Properties</a
        >
      </li>
    </ul>

    <div id="profile-settings-container">
      <div class="profile">
        <div *ngIf="currentUser">
          <div class="account-container">
            <a class="navbar-brand profile-photo">
              <img *ngIf="photoUrl" [src]="photoUrl" width="28" height="28"/>
            </a>
            <div class="navbar-text">{{ currentUser.name }}</div>
          </div>
        </div>
      </div>
      <div class="settings" (click)="openSettings()"><i class="bi bi-gear-fill"></i></div>
    </div>
  </div>
</nav>
<app-settings></app-settings>
